<template>
  <div class="image-container set-full-height">
    <!--   Creative Tim Branding   -->

    <!--  Made With Paper Kit  -->

    <!--   Big container   -->
    <div class="container" id="app">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2" align="left" style="margin-bottom: 25px">
          <button class="btn btn-danger" @click="blackMenu" style="color: red">กลับสู่หน้า Home</button>
        </div>
        <div class="col-sm-8 col-sm-offset-2" style="background-color:#fc8006">
          <h3 align="center" style="color:#fff; font-family:Prompt">ระบบทำบัตรออนไลน์ คณะแพทยศาสตร์
            ม.สงขลานครินทร์
            <a href="index.html" style="color:#fff"><i class="ti-home"></i></a></h3>

          <!--      Wizard container        -->
          <div class="wizard-container">
            <div class="card wizard-card" data-color="red" id="wizard">
              <form action="" method="">
                <div class="wizard-header">
                  <h3 class="wizard-title" style="color:#000; font-family:Prompt">
                    <u>แบบฟอร์มขอทำบัตรสำหรับญาติบุคลากร</u>
                  </h3>
                  <p class="category">====================================</p>
                </div>
                <div class="tab-content">
                  <div class="row">
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-4" style="top: 34px">
                      <div class="form-group" align="center">
                        <label>ทำบัตร</label><br>
                        <v-select
                            :items="CardTypeSelect"
                            item-text="name"
                            item-value="value"
                            label="ประเภททำบัตร"
                            v-model="StatusRegis"
                            @change="CheckStatusRegis"
                        ></v-select>
                      </div>
                    </div>
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-10 col-sm-offset-1" style="top: 34px"
                         v-if="StatusRegis != '1'">
                      <div class="form-group" align="center">
                        <label>รายชื่อญาติบุคลากร</label><br>
                        <select class="form-control" style="background-color:#dcfbdf"
                                v-model="StatusRelative"
                                @change="ChooseRelative(StatusRelative)">
                          <option :value="releiveI.id" v-for="releiveI in RelativeData"
                                  v-bind:key="releiveI.id">{{ releiveI.firstName }}
                            {{ releiveI.lastName }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-12"><br>

                      <h5 class="info-text"
                          style="font-family:Prompt; text-align:center;background-color:#fc8006; color:#fff">
                        &nbsp;&nbsp;1. ข้อมูลส่วนตัว(ญาติ)</h5>
                    </div>

                    <!--                                            <div class="col-sm-2">-->
                    <!--                                                <div class="form-group">-->
                    <!--                                                    <label>คำนำหน้า</label><br>-->
                    <!--                                                    <select  class="form-control" style="background-color:#f8e1cb">-->
                    <!--                                                        <option value="1">นาย</option>-->
                    <!--                                                        <option value="2">นาง</option>-->
                    <!--                                                        <option value="3">นางสาว</option>-->
                    <!--                                                    </select>-->
                    <!--                                                </div>-->
                    <!--                                            </div>-->
                    <v-container>
                      <v-list-item>
                        <v-row>
                          <v-col
                              md="6"
                              cols="12"
                          >
                            <v-text-field
                                outlined
                                label="ชื่อ(ภาษาไทย)"
                                v-model="nameTh"
                                :rules="[() => !!nameTh || 'ชื่อ(ภาษาไทย) ห้ามว่าง**']"
                                :readonly="StatusRegis != '1'"
                                :error="nameTh == ''"
                                :error-messages="nameTh == '' ? 'ชื่อ(ภาษาไทย) ห้ามว่าง' : ''"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              md="6"
                              cols="12"
                          >
                            <v-text-field
                                outlined
                                label="นามสกุล(ภาษาไทย)"
                                v-model="surnameTh"
                                :rules="[() => !!surnameTh || 'นามสกุล(ภาษาไทย) ห้ามว่าง**']"
                                :readonly="StatusRegis != '1'"
                                :error="surnameTh == ''"
                                :error-messages="surnameTh == '' ? 'นามสกุล(ภาษาไทย) ห้ามว่าง' : ''"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-row>
                          <v-col
                              md="6"
                              cols="12"
                          >
                            <v-text-field
                                outlined
                                label="เลขที่บัตรประชาชน 13 หลัก"
                                type="number"
                                v-model="idcard"
                                :rules="[() => !!idcard || 'เลขที่บัตรประชาชน 13 หลัก ห้ามว่าง**',
                                                                () => !!idcard && idcard.length == 13 || 'เลขที่บัตรประชาชน ต้องการ 13 ตัวอักษร']"
                                :readonly="StatusRegis != '1'"
                                :error="idcard == ''"
                                :error-messages="idcard == '' ? 'เลขที่บัตรประชาชน 13 หลัก ห้ามว่าง' : ''"
                                @keyup="autoTab"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              md="6"
                              cols="12"
                          >
                            <v-text-field
                                type="date"
                                outlined
                                label="วัน/เดือน/ปี เกิด"
                                v-model="brithDay"
                                :rules="[() => !!brithDay || 'วัน/เดือน/ปี เกิด ห้ามว่าง**']"
                                :readonly="StatusRegis != '1'"
                                :error="brithDay == ''"
                                :error-messages="brithDay == '' ? 'วัน/เดือน/ปี เกิด ห้ามว่าง' : ''"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-row>
                          <v-col
                              md="6"
                              cols="12"
                          >
                            <v-select
                                :items="GenderData"
                                item-text="name"
                                item-value="value"
                                outlined
                                label="เพศ"
                                v-model="gender"
                                :rules="[() => !!gender || 'เพศ ห้ามว่าง**']"
                                :readonly="StatusRegis != '1'"
                                :error="gender == ''"
                                :error-messages="gender == '' ? 'เพศ ห้ามว่าง' : ''"
                            ></v-select>
                          </v-col>
                          <v-col
                              md="6"
                              cols="12"
                          >
                            <v-text-field
                                outlined
                                label="โทรศัพท์เคลื่อนที่"
                                v-model="phoneMoblie"
                                :rules="[() => !!phoneMoblie || 'โทรศัพท์เคลื่อนที่ ห้ามว่าง**',
                                                                () => !!phoneMoblie && phoneMoblie.length == 10 || 'โทรศัพท์เคลื่อนที่่ ต้องการ 10 ตัวอักษร']"
                                :readonly="StatusRegis != '1'"
                                :error="phoneMoblie == ''"
                                :error-messages="phoneMoblie == '' ? 'โทรศัพท์เคลื่อนที่ ห้ามว่าง' : ''"
                                @keyup="autoTabMobile"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-row>
                          <v-col
                              md="6"
                              cols="12"
                          >
                            <v-text-field
                                outlined
                                label="โทรศัพท์บ้าน"
                                v-model="phoneHome"
                                :readonly="StatusRegis != '1'"
                                @keyup="autoTabHome"
                            ></v-text-field>
                          </v-col>
                          <v-col
                              md="6"
                              cols="12"
                          >
                            <v-text-field
                                outlined
                                label="อีเมลล์"
                                v-model="email"
                                :readonly="StatusRegis != '1'"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-row>
                          <v-col
                              cols="12"
                          >
                            <v-text-field
                                outlined
                                label="ที่อยู่ตามบัตรประชาชน หรือ ทะเบียนบ้าน"
                                v-model="address"
                                :readonly="StatusRegis != '1'"
                                :rules="[() => !!address || 'ที่อยู่ตามบัตรประชาชน หรือ ทะเบียนบ้าน ห้ามว่าง**']"
                                :error="address == ''"
                                :error-messages="address == '' ? 'ที่อยู่ตามบัตรประชาชน หรือ ทะเบียนบ้าน ห้ามว่าง' : ''"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </v-container>

                    <div class="row" align="center" style="padding: 10px">
                      <div class="col-md-12 col-12">
                        <p style="color: #761c19;font-weight: bold">กรณีต้องการเปิดสิทธิ์แขนกั้นโซนหอพัก
                          ให้กับญาติกรุณากรอกข้อมูลด้านล่างพร้อมแนบหลักฐาน</p>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label>ทะเบียนรถ</label>
                          <input type="text" class="form-control" v-model="vehicleReg"
                                 id="vehicleReg"
                                 placeholder="" value="" style="background-color:#f8e1cb"
                                 :disabled="StatusRegis == '2'">
                        </div>
                      </div>

                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label>จังหวัด</label><br>
                          <select class="form-control" style="background-color:#f8e1cb"
                                  v-model="vehicleRegProvice"
                                  :disabled="StatusRegis == '2'">
                            <option v-for="optionItem in ProviceData"
                                    v-bind:key="optionItem.id" :value="optionItem.id">
                              {{ optionItem.name_in_thai }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12">
                      <h5 class="info-text"
                          style="font-family:Prompt; text-align:center;background-color:#fc8006;color:#fff">
                        &nbsp;&nbsp;2. ข้อมูลที่พักบุคลากร(ภายในคณะแพทยศาสตร์)</h5>
                    </div>

                    <div class="col-sm-5 col-sm-offset-1">
                      <div class="form-group">
                        <label>หอพัก</label>
                        <input type="text" class="form-control" v-model="dorm" id="dorm"
                               placeholder="" value="-" style="background-color:#9a9a9a;color: red"
                               disabled>
                      </div>
                      <div class="form-group">
                        <p style="color: rgba(185,67,23,0.99);text-align: left;font-size: 14px"
                           v-if="dorm == ''">
                          หอพัก ห้ามว่าง**
                        </p>
                      </div>
                    </div>

                    <div class="col-sm-5">
                      <div class="form-group">
                        <label>ห้องพัก</label><br>
                        <input type="text" class="form-control" v-model="dorm2" id="dorm2"
                               placeholder="" value="-" style="background-color:#9a9a9a;color: red"
                               disabled>
                      </div>
                      <div class="form-group">
                        <p style="color: rgba(185,67,23,0.99);text-align: left;font-size: 14px"
                           v-if="dorm2 == ''">
                          ห้องพัก ห้ามว่าง**
                        </p>
                      </div>
                    </div>

                  </div>


                  <div class="row">
                    <div class="col-sm-12"><br>

                      <h5 class="info-text"
                          style="font-family:Prompt; text-align:center;background-color:#fc8006;color:#fff">
                        &nbsp;&nbsp;หลักฐานประกอบการทำญาติ</h5>
                    </div>
                    <div class="col-sm-10 col-sm-offset-1" v-if="StatusRegis == '2'" แ>
                      <v-radio-group row v-model="ChooseTypePic" @change="ChooseTypePicFunc">
                        <v-radio label="อัพโหลดรูปภาพใหม่" value="0"></v-radio>
                        <v-radio label="ใช้รูปภาพเดิม" value="1"></v-radio>
                      </v-radio-group>
                    </div>
                    <div class="col-sm-10 col-sm-offset-1" v-if="ChooseTypePic == '0'">
                      <div class="form-group">
                        <span :style="ChangeStyle">1) รูปถ่าย ขนาด 1 นิ้ว (หน้าตรง ไม่สวมหมวก ไม่สวมแว่นดำ)</span> <span
                          style="background-color: red;color: white"> ( ถ่ายมาแล้วไม่เกิน 6 เดือน )</span>
                        <input type="file" class="form-control" id="pic"
                               placeholder="" style="background-color:#f8e1cb"
                               @change="onFileSelected">
                      </div>
                      <div class="form-group">
                        <p style="color: rgba(185,67,23,0.99);text-align: left;font-size: 14px"
                           v-if="selectFile == ''">
                          รูปถ่าย ห้ามว่าง**
                        </p>
                      </div>
                    </div>
                    <div class="col-sm-10 col-sm-offset-1" v-else align="center">
                      <v-img
                          :src="urlPic + PicProfile"
                          max-height="300"
                          max-width="300"
                          Contain
                      ></v-img>
                    </div>

                    <v-divider></v-divider>
                    <div class="col-sm-10 col-sm-offset-1" align="center"
                         v-if="StatusRegis == '1'">
                      <div class="form-group">
                        <span :style="ChangeStyle">2) สำเนาบัตรประจำตัวประชาชน พร้อมรับรองสำเนาถูกต้อง</span>
                        <input type="file" class="form-control" id="pic2"
                               placeholder="" style="background-color:#f8e1cb"
                               @change="FileSelectPersonal">
                      </div>
                      <div class="form-group">
                        <p style="color: rgba(185,67,23,0.99);text-align: left;font-size: 14px"
                           v-if="ImagePersonCopy == ''">
                          สำเนาบัตรประจำตัวประชาชน ห้ามว่าง**
                        </p>
                      </div>
                      <img v-if="ImagePersonCopyType" :src="ImagePersonCopy"
                           class="img-responsive"/>
                      <iframe v-if="pdfPersonCopyType" :src="ImagePersonCopy"
                              style="width:400px; height:300px;" frameborder="0"></iframe>
                    </div>

                    <v-divider></v-divider>
                    <div class="col-sm-10 col-sm-offset-1" align="center">
                      <div class="form-group">
                        <span :style="ChangeStyle">3) ใบเสร็จรับเงิน งานคลัง คณะแพทยศาสตร์ (เท่านั้น !!!)</span>
                        <input type="file" class="form-control" id="pic3"
                               placeholder="" style="background-color:#f8e1cb"
                               @change="FileSelectRecript">
                      </div>
                      <div class="form-group">
                        <p style="color: rgba(185,67,23,0.99);text-align: left;font-size: 14px"
                           v-if="ImageRecript == ''">
                          ใบเสร็จรับเงิน งานคลัง คณะแพทยศาสตร์ ห้ามว่าง**
                        </p>
                      </div>
                      <div class="form-group">
                        <p :style="ChangeStyle">
                          กรณาชำระเงิน (200 บาท!!!) ที่งานคลัง ชั้น 3 อาคารบริหาร ภายในวันและเวลาราชการตั้งแต่เวลา 8.30
                          น. ถึง 11.45 น. และ 13.00 ถึง 15.30 น. !!****ยกเลิกการใช้สลิปโอนเงินค่ะ****!!
                        </p>
                      </div>
                      <img v-if="ImageRecriptType" :src="ImageRecript"
                           class="img-responsive"/>
                      <iframe v-if="pdfRecriptType" :src="ImageRecript"
                              style="width:400px; height:300px;" frameborder="0"></iframe>
                    </div>
                    <v-divider></v-divider>
                    <div class="col-sm-10 col-sm-offset-1" v-if="StatusRegis == '4'">
                      <v-radio-group row v-model="ChooseTypePic2" @change="ChooseTypePicFunc2">
                        <v-radio label="อัพโหลดทะเบียนรถใหม่ (กรณีเปลื่ยนรถยนต์ )" value="0"></v-radio>
                        <v-radio label="ใช้รูปหลักฐานเดิม" value="1"></v-radio>
                      </v-radio-group>
                    </div>
                    <div class="col-sm-10 col-sm-offset-1" align="center"
                         v-if="StatusRegis == '1' || StatusRegis == '4'">
                      <div class="form-group" v-if="ChooseTypePic2 == '0'">
                        <span :style="ChangeStyle">4) สำเนาคู่มือทะเบียนรถ พร้อมรับรองสำเนาถูกต้อง</span>
                        <input type="file" class="form-control" id="pic4"
                               placeholder="" style="background-color:#f8e1cb"
                               @change="FileSelectHome">
                      </div>
                      <div class="form-group">
                        <p style="color: rgba(70,108,185,0.99);text-align: left;font-size: 14px">
                          แนบสำเนาคู่มือทะเบียนรถ กรณีต้องการเปิดสิทธิ์แขนกั้น
                        </p>
                      </div>
                      <!--<div class="form-group">
                          <p style="color: rgba(185,67,23,0.99);text-align: left;font-size: 14px"
                             v-if="ImageHome == ''">
                              สำเนาทะเบียนรถ ห้ามว่าง**
                          </p>
                      </div>-->
                      <img v-if="ImageHomeType && ChooseTypePic2 == '0'" :src="ImageHome"
                           class="img-responsive"/>
                      <iframe v-if="pdfHomeType" :src="ImageHome"
                              style="width:400px; height:300px;" frameborder="0"></iframe>
                    </div>

                  </div>


                  <div class="row" v-if="ChooseTypePic == '0'">
                    <div class="col-sm-12"><br>

                      <h5 class="info-text"
                          style="font-family:Prompt; text-align:center;background-color:#fc8006;color:#fff">
                        &nbsp;&nbsp;ตัวอย่างบัตร</h5>
                    </div>

                    <div class="col-sm-12" align="center">
                      <p style="font-family:Prompt;color: black;font-weight: bold">
                        เลือกตำแหน่งรูปภาพ</p>
                      <div style="border: 2px solid;border-color: #327339;padding: 10px">
                        <div class="cropper-wrapper" style="width: 100%;">
                          <div :style="{backgroundImage: 'url(' + pic_Profile + ')'}"
                               class="cropper-background"></div>
                          <Cropper
                              :src="pic_Profile"
                              :restrictions="pixelsRestriction"
                              @change="onChangePic"
                          />
                        </div>
                        <button class="btn btn-warning" @click="rotate" style="margin-top: 15px">
                          ** หมุนรูปภาพ **
                        </button>
                      </div>

                    </div>

                    <div class="col-sm-6" style="margin-top: 15px;height: fit-content;width: 100%"
                         align="center"
                         v-if="nameTh != ''">
                      <div class="form-group"
                           style="text-align:center;height: 435px;width: fit-content">
                        <img src="../assets/img/c1.jpg" width="278" height="440">
                        <div
                            style="top: -164px;position: relative;left: 48px;width: 192px;font-weight: bold;font-size: 16px;text-align: center"
                            align="right">
                          <span>{{ nameTh }} {{ surnameTh }}</span>
                        </div>
                        <div
                            style="top: -134px;position: relative;left: 119px;width: 162px;font-weight: bold;font-size: 16px;text-align: left"
                            align="right">
                          <span>{{ perid }}</span>
                        </div>
                        <div
                            style="top: -132px;position: relative;left: 119px;width: 162px;font-weight: bold;font-size: 17px;text-align:left"
                            align="right">
                          <span>{{ namePerson }}</span>
                        </div>
                        <img :src="imageCrop" width="130" height="150"
                             style="position: relative;top: -395px;left: 5px;object-fit: contain;">
                        <div
                            style="top: -278px;position: relative;left: 119px;width: 162px;font-weight: bold;font-size: 17px;text-align:left"
                            align="right">
                          <span>{{ DateExpire | DateToThai }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6" style="margin-top: 15px;width: 100%" align="center" v-if="nameTh != ''">
                      <div class="form-group" style="text-align:center">
                        <img src="../assets/img/c2.jpg" width="278" height="440">

                      </div>
                    </div>


                  </div>


                  <div class="row">
                    <div class="col-sm-12"><br>

                      <h5 class="info-text"
                          style="font-family:Prompt; text-align:center;background-color:#fc8006;color:#fff">
                        &nbsp;&nbsp;ยืนยันข้อมูลการขอทำบัตร</h5>
                    </div>

                    <div class="col-sm-10 col-sm-offset-1">
                      <div class="form-group">
                        <h3 align="center" style="font-family:Prompt;">
                          ยืนยันข้อมูลการทำบัตร </h3>
                      </div>
                    </div>
                    <div class="col-sm-12" align="center">
                      <div class="pull-center">
                        <input type='button' class='btn btn-finish btn-fill btn-danger btn-wd'
                               value='ยืนยันข้อมูล' v-on:click="SubmitForm" :disabled="CheckSubmit"/>
                      </div>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div> <!-- wizard container -->
          <h5 align="center" style="color:#fff; font-family:prompt;">
            หน่วยรักษาความปลอดภัย ชั้น 2 อาคารบริหาร คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์ ติดต่อ
            074-45-1122
          </h5>
        </div>
        <div class="col-sm-8 col-sm-offset-2" align="left" style="margin-top: 25px">
          <button class="btn btn-danger" @click="blackMenu" style="color: red"> กลับสู่หน้า Home</button>
        </div>
      </div> <!-- row -->
    </div> <!--  big container -->
  </div>
</template>

<script>

import axios from 'axios'
import {Cropper} from 'vue-advanced-cropper'
import ConstData from '../Const/Const'
import queryString from "query-string";

const querystring = require('querystring');

export default {
  name: "Card2",
  data: function () {
    return {
      urlPic: ConstData.ConnectionHost + '/rest/files',
      PicProfile: '',
      Count: 3,
      FileHomeDump: '',
      ChooseTypePic: '0',
      ChooseTypePic2: '0',
      ChangeStyle: null,
      CheckSubmit: false,
      CardTypeSelect: [
        {
          'name': 'ใหม่',
          'value': '1'
        },
        {
          'name': 'หาย/ชำรุด',
          'value': '2'
        },
        {
          'name': 'ต่ออายุบัตร',
          'value': '4'
        }
      ],
      GenderData: [
        {
          'name': 'ชาย',
          'value': 'ชาย'
        },
        {
          'name': 'หญิง',
          'value': 'หญิง'
        }
      ],
      vehicleReg: '',
      vehicleRegProvice: '',
      ProviceData: [],
      valueOld: '',
      valuePhoneMobileOld: '',
      valuePhoneHomeOld: '',
      RelativeData: [],
      StatusRelative: '0',
      choosePic: true,
      StatusRegis: '1',
      ImagePerson: '',
      ImageRecript: '',
      ImagePersonCopy: '',
      ImageHome: '',
      ImagePersonUp: null,
      ImageRecriptUp: null,
      ImagePersonCopyUp: null,
      ImageHomeUp: null,
      ImagePersonType: '',
      pdfPersonType: '',
      ImageRecriptType: '',
      pdfRecriptType: '',
      ImagePersonCopyType: '',
      pdfPersonCopyType: '',
      ImageHomeType: '',
      pdfHomeType: '',
      perid: '',
      idcard: '',
      nameTh: '',
      surnameTh: '',
      nameEn: '',
      namePerson: '',
      hn: '',
      brithDay: '',
      gender: '',
      depart: '',
      phoneDepart: '',
      phoneMoblie: '',
      phoneHome: '',
      email: '',
      address: '',
      dorm: '',
      dorm2: '',
      car: '',
      car2: '',
      bike: '',
      bike2: '',
      options: {
        url: '/upload',
        paramName: 'file'
      },
      position: '',
      FilePersonal: '',
      FileRecript: '',
      FileHome: '',
      selectFile: '',
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      imageCrop: null,
      DateExpire: "",
      pic_Profile: require('@/assets/img/NonPic.png'),
      // pic_Profile: require('@/assets/img/ShowfPict.jpg'),
      dataFormSubmit: {
        request: {
          request_types_id: "2",
          request_wish_id: "1",
          quantity: "1",
          card_status: "1",
          expire_date: "",
        },
        items: [
          {
            person: {
              person_types_id: "4",
              perid: "",
              citizenId: "",
              firstName: "",
              lastName: "",
              birthdate: "",
              sex: "",
              license_plate: "",
              provinces_id: ""
            },
            contact: [
              {
                contact_types_id: "1",
                value: ""
              },
              {
                contact_types_id: "2",
                value: ""
              },
              {
                contact_types_id: "3",
                value: ""
              },
              {
                contact_types_id: "4",
                value: ""
              },
              {
                contact_types_id: "5",
                value: ""
              },
              {
                contact_types_id: "6",
                value: ""
              }
            ],
            dorm: [
              {
                dorm_types_id: "1",
                value: "-"
              },
              {
                dorm_types_id: "2",
                value: "-"
              }
            ],
            vehicle: [],
            attachment: [
              {
                attachment_types_id: "1",
                url: ""
              },
              {
                attachment_types_id: "2",
                url: ""
              },
              {
                attachment_types_id: "3",
                url: ""
              },
              {
                attachment_types_id: "4",
                url: ""
              },
              {
                attachment_types_id: "5",
                url: ""
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    rotate() {
      var image = document.createElement("img");
      image.crossOrigin = "anonymous";
      image.src = this.pic_Profile;
      image.onload = () => {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        if (image.width > image.height) {
          canvas.width = image.height;
          canvas.height = image.width;
          ctx.translate(image.height, image.width / image.height);
        } else {
          canvas.height = image.width;
          canvas.width = image.height;
          ctx.translate(image.height, image.width / image.height);
        }
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(image, 0, 0);
        this.pic_Profile = canvas.toDataURL();
      };
    },
    SendLineNotify() {
      var TypeCard = ''
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear() + 543;
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      if (hour.toString().length == 1) {
        hour = '0' + hour;
      }
      if (minute.toString().length == 1) {
        minute = '0' + minute;
      }
      if (second.toString().length == 1) {
        second = '0' + second;
      }

      today = dd + '/' + mm + '/' + yyyy + ' ' + hour + ':' + minute + ':' + second

      if (this.StatusRegis == '1') {
        TypeCard = 'ทำบัตรใหม่'
      } else if (this.StatusRegis == '2') {
        TypeCard = 'บัตรหาย/ชำรุด'
      } else {
        TypeCard = 'ต่ออายุบัตร'
      }

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/line_noti/').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              if (item.type == '2') {

                const param = querystring.stringify({
                  message: 'มีรายการสมัครบัตรญาติ แจ้งรายการ ( ' + TypeCard + ' ) เข้ามาใหม่ ' +
                      ' ชื่อ - สกุล ( ' + this.nameTh + ' ' + this.surnameTh + ' ) เป็นญาติของบุคลากร ( ' + this.namePerson + ' รหัส ' + this.perid + ' ) สมัครเมื่อวันที่ ' +
                      today,
                  Token: item.Line_Token
                })

                axios.post(ConstData.ConnectionHost + '/sendLineNotify.php', param)
              }
            })
          } else {
            if (res.data.type == '2') {

              const param = querystring.stringify({
                message: 'มีรายการสมัครบัตรญาติ แจ้งรายการ ( ' + TypeCard + ' ) เข้ามาใหม่ ' +
                    ' ชื่อ - สกุล ( ' + this.nameTh + ' ' + this.surnameTh + ' ) เป็นญาติของบุคลากร ( ' + this.namePerson + ' รหัส ' + this.perid + ' ) สมัครเมื่อวันที่ ' +
                    today,
                Token: res.data.Line_Token
              })

              axios.post(ConstData.ConnectionHost + '/sendLineNotify.php', param)
            }
          }
        }
      })
    },
    onChangePic({coordinates, canvas}) {

      this.coordinates = coordinates
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image
      this.imageCrop = canvas.toDataURL("image/png")
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
      else
        byteString = unescape(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type: mimeString});
    },
    pixelsRestriction({minWidth, minHeight, maxWidth, maxHeight}) {
      return {
        minWidth: minWidth,
        minHeight: minHeight,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
      }
    },
    getImageData() {
      return new Promise(resolve => {
        var blobImage = this.dataURItoBlob(this.imageCrop)
        // this.imageCrop = canvas.toDataURL()

        const fd = new FormData()
        fd.append('file', blobImage, this.ImageName)
        const headerAxios = {
          headers: {
            'Content-Type': 'multipart/form-data',
            'WithCredentials': true,
            "Access-Control-Allow-Origin": "*"
            // "Accept": 'multipart/form-data'
          }
        }

        axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
          if (res.data.status) {
            resolve({
              result: true,
              picPath: res.data.path
            })
          } else {
            resolve({
              result: false,
              picPath: ''
            })
          }
        })
      })
    },
    SubmitForm: function () {
      this.CheckSubmit = true
      if (this.idcard.length != 13) {
        this.CheckSubmit = false
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด',
          text: 'คุณกรอกเลขบัตรประชาชนไม่ถูกต้อง กรุณากรอกอีกครั้ง'
        })
        this.idcard = ''
      } else {
        if (this.dataFormSubmit.request.request_wish_id == '2') {
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_wish_id/1/perid/' + this.perid + '/request_types_id/2/firstName/' + this.nameTh + '/lastName/' + this.surnameTh + '/card_status/1/?sort=id_DESC&limit=1').then(res => {
            if (res.data) {
              if (res.data.status_id == '5') {
                if (this.nameTh == '' || this.surnameTh == '' || this.idcard == '' || this.brithDay == '' || this.gender == '' || this.phoneMoblie == ''
                    || this.address == '' || this.selectFile == '' || this.ImageRecript == '' || this.ImagePersonCopy == '' ||
                    this.dorm == '' || this.dorm2 == '') {
                  this.CheckSubmit = false
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'โปรดกรอกข้อมูลให้ครบถ้วน'
                  })
                } else {

                  if (this.ChooseTypePic == '0') {
                    this.getImageData().then(resImng => {
                      if (resImng.result) {
                        this.selectFile = resImng.picPath

                        if (new Date().getDate() < 10 && (new Date().getMonth() + 1) < 10) {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                        } else if (new Date().getDate() > 10 && (new Date().getMonth() + 1) < 10) {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
                        } else if (new Date().getDate() < 10 && (new Date().getMonth() + 1) > 10) {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                        } else {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                        }

                        this.dataFormSubmit.items[0].person.perid = this.perid;
                        this.dataFormSubmit.items[0].person.citizenId = this.idcard;
                        this.dataFormSubmit.items[0].person.firstName = this.nameTh;
                        this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
                        this.dataFormSubmit.items[0].person.birthdate = this.brithDay
                        this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');
                        this.dataFormSubmit.items[0].person.license_plate = this.vehicleReg;
                        this.dataFormSubmit.items[0].person.provinces_id = this.vehicleRegProvice

                        this.dataFormSubmit.items[0].contact.map((element) => {
                          switch (element.contact_types_id) {
                            case "1":
                              element.value = this.$data.email;
                              break;
                            case "2":
                              element.value = this.$data.depart;
                              break;
                            case "3":
                              element.value = this.$data.phoneDepart;
                              break;
                            case "4":
                              element.value = this.$data.phoneMoblie;
                              break;
                            case "5":
                              element.value = this.$data.phoneHome;
                              break;
                            default:
                              element.value = this.$data.address;
                              break;
                          }
                        })

                        this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                          switch (attachmentData.attachment_types_id) {
                            case "1":
                              attachmentData.url = this.selectFile;
                              break;
                            case "2" :
                              attachmentData.url = this.ImagePersonCopy;
                              break;
                            case "3" :
                              attachmentData.url = this.FileRecript;
                              break;
                            case "4" :
                              attachmentData.url = this.FileHomeDump;
                              break;
                            default :
                              break;
                          }
                        })

                        const headerAxios = {
                          headers: {
                            'Content-Type': 'application/json',
                          }
                        }

                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_wish_id/2/perid/' + this.perid + '/request_types_id/2/firstName/' + this.nameTh + '/lastName/' + this.surnameTh + '/card_status/1/?sort=id_DESC&limit=1').then(resCheck => {
                          if (resCheck.data) {
                            var CheckData = false
                            if (resCheck.data.length > 0) {
                              var CheckData2 = resCheck.data.filter(itemCheck => itemCheck.status_id != '5' && itemCheck.status_id != '3')
                              if (CheckData2.length > 0) {
                                CheckData = true
                              }
                            } else {
                              if (resCheck.data.status_id != '5' && resCheck.data.status_id != '3') {
                                CheckData = true
                              }
                            }
                            if (!CheckData) {
                              axios
                                  .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                                  .then(res => {
                                    if (res.data.status) {
                                      this.SendLineNotify()
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                      this.$router.push('/')
                                    } else {
                                      this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                                    }
                                  })
                            } else {
                              this.CheckSubmit = false
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด',
                                text: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากรายชื่อที่เลือกมีประวัติรายการขอทำบัตร หาย/ชำรุด ยังไม่เสร็จสิ้นขั้นตอนการจ่ายบัตร',
                              })
                            }
                          } else {
                            axios
                                .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                                .then(res => {
                                  if (res.data.status) {
                                    this.SendLineNotify()
                                    this.$swal.fire({
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลสำเร็จ'
                                    })
                                    this.$router.push('/')
                                  } else {
                                    this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                                  }
                                })
                          }
                        })

                      }
                    })
                  } else {
                    if (new Date().getDate() < 10 && (new Date().getMonth() + 1) < 10) {
                      this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                    } else if (new Date().getDate() > 10 && (new Date().getMonth() + 1) < 10) {
                      this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
                    } else if (new Date().getDate() < 10 && (new Date().getMonth() + 1) > 10) {
                      this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                    } else {
                      this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                    }

                    this.dataFormSubmit.items[0].person.perid = this.perid;
                    this.dataFormSubmit.items[0].person.citizenId = this.idcard;
                    this.dataFormSubmit.items[0].person.firstName = this.nameTh;
                    this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
                    this.dataFormSubmit.items[0].person.birthdate = this.brithDay
                    this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');
                    this.dataFormSubmit.items[0].person.license_plate = this.vehicleReg;
                    this.dataFormSubmit.items[0].person.provinces_id = this.vehicleRegProvice

                    this.dataFormSubmit.items[0].contact.map((element) => {
                      switch (element.contact_types_id) {
                        case "1":
                          element.value = this.$data.email;
                          break;
                        case "2":
                          element.value = this.$data.depart;
                          break;
                        case "3":
                          element.value = this.$data.phoneDepart;
                          break;
                        case "4":
                          element.value = this.$data.phoneMoblie;
                          break;
                        case "5":
                          element.value = this.$data.phoneHome;
                          break;
                        default:
                          element.value = this.$data.address;
                          break;
                      }
                    })

                    this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                      switch (attachmentData.attachment_types_id) {
                        case "1":
                          attachmentData.url = this.selectFile;
                          break;
                        case "2" :
                          attachmentData.url = this.ImagePersonCopy;
                          break;
                        case "3" :
                          attachmentData.url = this.FileRecript;
                          break;
                        case "4" :
                          attachmentData.url = this.FileHomeDump;
                          break;
                        default :
                          break;
                      }
                    })

                    const headerAxios = {
                      headers: {
                        'Content-Type': 'application/json',
                      }
                    }

                    axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_wish_id/2/perid/' + this.perid + '/request_types_id/2/firstName/' + this.nameTh + '/lastName/' + this.surnameTh + '/card_status/1/?sort=id_DESC&limit=1').then(resCheck => {
                      if (resCheck.data) {
                        var CheckData = false
                        if (resCheck.data.length > 0) {
                          var CheckData2 = resCheck.data.filter(itemCheck => itemCheck.status_id != '5' && itemCheck.status_id != '3')
                          if (CheckData2.length > 0) {
                            CheckData = true
                          }
                        } else {
                          if (resCheck.data.status_id != '5' && resCheck.data.status_id != '3') {
                            CheckData = true
                          }
                        }
                        if (!CheckData) {
                          axios
                              .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                              .then(res => {
                                if (res.data.status) {
                                  this.SendLineNotify()
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                  this.$router.push('/')
                                } else {
                                  this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                                }
                              })
                        } else {
                          this.CheckSubmit = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผิดพลาด',
                            text: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากรายชื่อที่เลือกมีประวัติรายการขอทำบัตร หาย/ชำรุด ยังไม่เสร็จสิ้นขั้นตอนการจ่ายบัตร',
                          })
                        }
                      } else {
                        axios
                            .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                            .then(res => {
                              if (res.data.status) {
                                this.SendLineNotify()
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                                this.$router.push('/')
                              } else {
                                this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                              }
                            })
                      }
                    })

                  }
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้',
                  text: 'เนื่องจากรายชื่อที่ถูกเลือก เคยมีประวัติการทำรายการมาก่อน และยังไม่เสร็จสิ้นขั้นตอนดำเนินการจ่ายบัตร'
                })
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้',
                text: 'โปรดตรวจสอบเครือข่าย'
              })
            }
          })
        } else if (this.dataFormSubmit.request.request_wish_id == '4') {
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_wish_id/1/perid/' + this.perid + '/request_types_id/2/firstName/' + this.nameTh + '/lastName/' + this.surnameTh + '/card_status/1/?sort=id_DESC&limit=1').then(res => {
            if (res.data) {
              if (res.data.status_id == '5') {
                if (this.nameTh == '' || this.surnameTh == '' || this.idcard == '' || this.brithDay == '' || this.gender == '' || this.phoneMoblie == ''
                    || this.address == '' || this.selectFile == '' || this.ImageRecript == '' || this.ImagePersonCopy == '' ||
                    this.dorm == '' || this.dorm2 == '') {
                  this.CheckSubmit = false
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'โปรดกรอกข้อมูลให้ครบถ้วน'
                  })
                } else if (this.ChooseTypePic2 == '0' && this.FileHome == '') {
                  this.CheckSubmit = false
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'กรุณาอัพโหลดทะเบียนรถ'
                  })
                } else if (this.selectFile == 'img/NonPic.png') {
                  this.CheckSubmit = false
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'กรุณาอัพโหลดรูปภาพใหม่'
                  })
                } else {
                  var blobImage = this.dataURItoBlob(this.imageCrop)
                  // this.imageCrop = canvas.toDataURL()

                  const fd = new FormData()
                  fd.append('file', blobImage, this.ImageName)
                  const headerAxios = {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      'WithCredentials': true,
                      "Access-Control-Allow-Origin": "*"
                      // "Accept": 'multipart/form-data'
                    }
                  }

                  axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                    if (res.data.status) {

                      this.selectFile = res.data.path

                      if (this.ChooseTypePic2 == '0') {

                        if (new Date().getDate() < 10 && (new Date().getMonth() + 1) < 10) {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                        } else if (new Date().getDate() > 10 && (new Date().getMonth() + 1) < 10) {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
                        } else if (new Date().getDate() < 10 && (new Date().getMonth() + 1) > 10) {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                        } else {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                        }

                        this.dataFormSubmit.items[0].person.perid = this.perid;
                        this.dataFormSubmit.items[0].person.citizenId = this.idcard;
                        this.dataFormSubmit.items[0].person.firstName = this.nameTh;
                        this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
                        this.dataFormSubmit.items[0].person.birthdate = this.brithDay
                        this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');
                        this.dataFormSubmit.items[0].person.license_plate = this.vehicleReg;
                        this.dataFormSubmit.items[0].person.provinces_id = this.vehicleRegProvice

                        this.dataFormSubmit.items[0].contact.map((element) => {
                          switch (element.contact_types_id) {
                            case "1":
                              element.value = this.$data.email;
                              break;
                            case "2":
                              element.value = this.$data.depart;
                              break;
                            case "3":
                              element.value = this.$data.phoneDepart;
                              break;
                            case "4":
                              element.value = this.$data.phoneMoblie;
                              break;
                            case "5":
                              element.value = this.$data.phoneHome;
                              break;
                            default:
                              element.value = this.$data.address;
                              break;
                          }
                        })

                        this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                          switch (attachmentData.attachment_types_id) {
                            case "1":
                              attachmentData.url = this.selectFile;
                              break;
                            case "2" :
                              attachmentData.url = this.ImagePersonCopy;
                              break;
                            case "3" :
                              attachmentData.url = this.FileRecript;
                              break;
                            case "4" :
                              attachmentData.url = this.FileHome;
                              break;
                            default :
                              break;
                          }
                        })

                        const headerAxios = {
                          headers: {
                            'Content-Type': 'application/json',
                          }
                        }

                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_wish_id/2/perid/' + this.perid + '/request_types_id/2/firstName/' + this.nameTh + '/lastName/' + this.surnameTh + '/card_status/1/?sort=id_DESC&limit=1').then(resCheck => {
                          if (resCheck.data) {
                            var CheckData = false
                            if (resCheck.data.length > 0) {
                              var CheckData2 = resCheck.data.filter(itemCheck => itemCheck.status_id != '5' && itemCheck.status_id != '3')
                              if (CheckData2.length > 0) {
                                CheckData = true
                              }
                            } else {
                              if (resCheck.data.status_id != '5' && resCheck.data.status_id != '3') {
                                CheckData = true
                              }
                            }
                            if (!CheckData) {
                              axios
                                  .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                                  .then(res => {
                                    if (res.data.status) {
                                      this.SendLineNotify()
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                      this.$router.push('/')
                                    } else {
                                      this.CheckSubmit = false
                                      this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                                    }
                                  })
                            } else {
                              this.CheckSubmit = false
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด',
                                text: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากรายชื่อที่เลือกมีประวัติรายการขอทำบัตร ต่ออายุบัตร ยังไม่เสร็จสิ้นขั้นตอนการจ่ายบัตร',
                              })
                            }
                          } else {
                            axios
                                .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                                .then(res => {
                                  if (res.data.status) {
                                    this.SendLineNotify()
                                    this.$swal.fire({
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลสำเร็จ'
                                    })
                                    this.$router.push('/')
                                  } else {
                                    this.CheckSubmit = false
                                    this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                                  }
                                })
                          }
                        })

                      } else {
                        if (new Date().getDate() < 10 && (new Date().getMonth() + 1) < 10) {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                        } else if (new Date().getDate() > 10 && (new Date().getMonth() + 1) < 10) {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
                        } else if (new Date().getDate() < 10 && (new Date().getMonth() + 1) > 10) {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                        } else {
                          this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                        }

                        this.dataFormSubmit.items[0].person.perid = this.perid;
                        this.dataFormSubmit.items[0].person.citizenId = this.idcard;
                        this.dataFormSubmit.items[0].person.firstName = this.nameTh;
                        this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
                        this.dataFormSubmit.items[0].person.birthdate = this.brithDay
                        this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');
                        this.dataFormSubmit.items[0].person.license_plate = this.vehicleReg;
                        this.dataFormSubmit.items[0].person.provinces_id = this.vehicleRegProvice

                        this.dataFormSubmit.items[0].contact.map((element) => {
                          switch (element.contact_types_id) {
                            case "1":
                              element.value = this.$data.email;
                              break;
                            case "2":
                              element.value = this.$data.depart;
                              break;
                            case "3":
                              element.value = this.$data.phoneDepart;
                              break;
                            case "4":
                              element.value = this.$data.phoneMoblie;
                              break;
                            case "5":
                              element.value = this.$data.phoneHome;
                              break;
                            default:
                              element.value = this.$data.address;
                              break;
                          }
                        })

                        this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                          switch (attachmentData.attachment_types_id) {
                            case "1":
                              attachmentData.url = this.selectFile;
                              break;
                            case "2" :
                              attachmentData.url = this.ImagePersonCopy;
                              break;
                            case "3" :
                              attachmentData.url = this.FileRecript;
                              break;
                            case "4" :
                              attachmentData.url = this.FileHomeDump;
                              break;
                            default :
                              break;
                          }
                        })

                        const headerAxios = {
                          headers: {
                            'Content-Type': 'application/json',
                          }
                        }

                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_wish_id/2/perid/' + this.perid + '/request_types_id/2/firstName/' + this.nameTh + '/lastName/' + this.surnameTh + '/card_status/1/?sort=id_DESC&limit=1').then(resCheck => {
                          if (resCheck.data) {
                            var CheckData = false
                            if (resCheck.data.length > 0) {
                              var CheckData2 = resCheck.data.filter(itemCheck => itemCheck.status_id != '5' && itemCheck.status_id != '3')
                              if (CheckData2.length > 0) {
                                CheckData = true
                              }
                            } else {
                              if (resCheck.data.status_id != '5' && resCheck.data.status_id != '3') {
                                CheckData = true
                              }
                            }
                            if (!CheckData) {
                              axios
                                  .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                                  .then(res => {
                                    if (res.data.status) {
                                      this.SendLineNotify()
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                      this.$router.push('/')
                                    } else {
                                      this.CheckSubmit = false
                                      this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                                    }
                                  })
                            } else {
                              this.CheckSubmit = false
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด',
                                text: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากรายชื่อที่เลือกมีประวัติรายการขอทำบัตร ต่ออายุบัตร ยังไม่เสร็จสิ้นขั้นตอนการจ่ายบัตร',
                              })
                            }
                          } else {
                            axios
                                .post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios)
                                .then(res => {
                                  if (res.data.status) {
                                    this.SendLineNotify()
                                    this.$swal.fire({
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลสำเร็จ'
                                    })
                                    this.$router.push('/')
                                  } else {
                                    this.CheckSubmit = false
                                    this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                                  }
                                })
                          }
                        })

                      }
                    }
                  })
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้',
                  text: 'เนื่องจากรายชื่อที่ถูกเลือก เคยมีประวัติการทำรายการมาก่อน และยังไม่เสร็จสิ้นขั้นตอนดำเนินการจ่ายบัตร'
                })
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้',
                text: 'โปรดตรวจสอบเครือข่าย'
              })
            }
          })
        } else {
          if (this.nameTh == '' || this.surnameTh == '' || this.idcard == '' || this.brithDay == '' || this.gender == '' || this.phoneMoblie == ''
              || this.address == '' || this.selectFile == '' || this.ImageRecript == '' || this.ImagePersonCopy == '' ||
              this.dorm == '' || this.dorm2 == '') {
            this.CheckSubmit = false
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'โปรดกรอกข้อมูลให้ครบถ้วน'
            })
          } else {

            var blobImage = this.dataURItoBlob(this.imageCrop)
            // this.imageCrop = canvas.toDataURL()

            const fd = new FormData()
            fd.append('file', blobImage, this.ImageName)
            const headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
              if (res.data.status) {

                this.selectFile = res.data.path

                if (new Date().getDate() < 10 && (new Date().getMonth() + 1) < 10) {
                  this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                } else if (new Date().getDate() > 10 && (new Date().getMonth() + 1) < 10) {
                  this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
                } else if (new Date().getDate() < 10 && (new Date().getMonth() + 1) > 10) {
                  this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                } else {
                  this.dataFormSubmit.request.expire_date = (new Date().getFullYear() + 2) + '-0' + (new Date().getMonth() + 1) + '-0' + new Date().getDate()
                }

                this.dataFormSubmit.items[0].person.perid = this.perid;
                this.dataFormSubmit.items[0].person.citizenId = this.idcard;
                this.dataFormSubmit.items[0].person.firstName = this.nameTh;
                this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
                this.dataFormSubmit.items[0].person.birthdate = this.brithDay
                this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');
                this.dataFormSubmit.items[0].person.license_plate = this.vehicleReg;
                this.dataFormSubmit.items[0].person.provinces_id = this.vehicleRegProvice

                this.dataFormSubmit.items[0].contact.map((element) => {
                  switch (element.contact_types_id) {
                    case "1":
                      element.value = this.$data.email;
                      break;
                    case "2":
                      element.value = this.$data.depart;
                      break;
                    case "3":
                      element.value = this.$data.phoneDepart;
                      break;
                    case "4":
                      element.value = this.$data.phoneMoblie;
                      break;
                    case "5":
                      element.value = this.$data.phoneHome;
                      break;
                    default:
                      element.value = this.$data.address;
                      break;
                  }
                })

                this.dataFormSubmit.items[0].attachment.map((attachmentData) => {
                  switch (attachmentData.attachment_types_id) {
                    case "1":
                      attachmentData.url = this.selectFile;
                      break;
                    case "2" :
                      attachmentData.url = this.FilePersonal;
                      break;
                    case "3" :
                      attachmentData.url = this.FileRecript;
                      break;
                    case "4" :
                      attachmentData.url = this.FileHome;
                      break;
                    default :
                      break;
                  }
                })

                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                  }
                }

                axios
                    .get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_types_id/2/request_wish_id/1/perid/' + this.perid.trim() + '/?limit=1000', this.dataFormSubmit, headerAxios)
                    .then(res => {
                      if (res.data.length >= 3) {
                        var count = 1
                        res.data.map((item) => {
                          if (parseInt(item.status_id) != 3) {
                            count++
                          }
                        })
                        if (count > this.Count) {
                          this.CheckSubmit = false
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผิดพลาด',
                            text: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากไม่สามารถทำบัตรญาติ ได้เกิน ' + this.Count + ' ใบ',
                          })
                        } else {
                          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios).then(res => {
                            if (res.data.status) {
                              this.SendLineNotify()
                              this.CheckSubmit = false
                              this.$swal.fire({
                                icon: 'success',
                                title: 'บันทึกข้อมูลสำเร็จ'
                              })
                              this.$router.push('/')
                            } else {
                              this.CheckSubmit = false
                              this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                            }
                          })
                        }
                      } else {
                        axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/create-request', this.dataFormSubmit, headerAxios).then(res => {
                          if (res.data.status) {
                            this.SendLineNotify()
                            this.CheckSubmit = false
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                            this.$router.push('/')
                          } else {
                            this.$swal('พบข้อผิดพลาดไม่สามารถบันทึกข้อมูลได้');
                          }
                        })
                      }
                    })
              } else {
                this.selectFile = ''
              }
            })

          }
        }
      }

    },
    FileSelectPersonal: function (event) {
      this.ImagePersonCopy = ''
      if (event.target.files[0]) {
        var Checkfile = false;
        switch (this.getExtension(event.target.files[0].name).toLowerCase()) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            this.ImagePersonCopyType = true
            this.pdfPersonCopyType = false
            this.ImagePersonCopy = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          case 'pdf':
            this.pdfPersonCopyType = true
            this.ImagePersonCopyType = false
            this.ImagePersonCopy = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          default:
            Checkfile = false;
            this.ImagePersonCopyType = false
            this.pdfPersonCopyType = false
            this.ImagePersonCopy = ''
            break
        }
        if (Checkfile) {

          if (event.target.files[0].size > 4096 * 4096) {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สนับสนุนไฟล์เกิน 4 mb'
            })
            this.ImagePersonCopyType = false
            this.pdfPersonCopyType = false
            this.ImagePersonCopy = ''
          } else {

            const fd = new FormData()
            fd.append('file', event.target.files[0], event.target.files[0].name)
            const headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
              if (res.data.status) {
                this.FilePersonal = res.data.path
              } else {
                this.FilePersonal = ''
              }
            })
          }

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + this.getExtension(event.target.files[0].name).toLowerCase()
          })
        }


      } else {
        this.ImagePersonCopyType = false
        this.pdfPersonCopyType = false
        this.ImagePersonCopy = ''
        this.FilePersonal = ''
      }
    },
    FileSelectRecript: function (event) {
      this.ImageRecript = ''
      if (event.target.files[0]) {
        var Checkfile = false;
        switch (this.getExtension(event.target.files[0].name).toLowerCase()) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            this.ImageRecriptType = true
            this.pdfRecriptType = false
            this.ImageRecript = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          case 'pdf':
            this.pdfRecriptType = true
            this.ImageRecriptType = false
            this.ImageRecript = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          default:
            Checkfile = false;
            this.ImageRecriptType = false
            this.pdfRecriptType = false
            this.ImageRecript = ''
            break
        }
        if (Checkfile) {
          if (event.target.files[0].size > 4096 * 4096) {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สนับสนุนไฟล์เกิน 4 mb'
            })
            this.ImageRecriptType = false
            this.pdfRecriptType = false
            this.ImageRecript = ''
          } else {
            const fd = new FormData()
            fd.append('file', event.target.files[0], event.target.files[0].name)
            const headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
              if (res.data.status) {
                this.FileRecript = res.data.path
              } else {
                this.FileRecript = ''
              }
            })
          }

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + this.getExtension(event.target.files[0].name).toLowerCase()
          })
        }

      } else {
        this.ImageRecriptType = false
        this.pdfRecriptType = false
        this.ImageRecript = ''
        this.FileRecript = ''
      }
    },
    FileSelectHome: function (event) {

      if (event.target.files[0]) {
        var Checkfile = false;
        switch (this.getExtension(event.target.files[0].name).toLowerCase()) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            this.ImageHomeType = true
            this.pdfHomeType = false
            this.ImageHome = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          case 'pdf':
            this.pdfHomeType = true
            this.ImageHomeType = false
            this.ImageHome = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          default:
            Checkfile = false;
            this.ImageHomeType = false
            this.pdfHomeType = false
            this.ImageHome = ''
            break
        }
        if (Checkfile) {
          if (event.target.files[0].size > 4096 * 4096) {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สนับสนุนไฟล์เกิน 4 mb'
            })
            this.ImageHomeType = false
            this.pdfHomeType = false
            this.ImageHome = ''
          } else {

            const fd = new FormData()
            fd.append('file', event.target.files[0], event.target.files[0].name)
            const headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
              if (res.data.status) {
                this.FileHome = res.data.path
              } else {
                this.FileHome = ''
              }
            })
          }

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + this.getExtension(event.target.files[0].name).toLowerCase()
          })
        }

      } else {
        this.ImageHomeType = false
        this.pdfHomeType = false
        this.ImageHome = ''
        this.FileHome = ''
      }
    },
    onFileSelected: function (event) {
      this.selectFile = ''
      if (event.target.files[0]) {
        var Checkfile = false;
        switch (this.getExtension(event.target.files[0].name).toLowerCase()) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            Checkfile = true;
            break
          default:
            Checkfile = false;
            this.pic_Profile = require('@/assets/img/NonPic.png')
            break
        }
        if (Checkfile) {
          /*if (event.target.files[0].size > 4096 * 4096) {
              this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'ไม่สนับสนุนไฟล์เกิน 4 mb'
              })
              this.selectFile = ''
          } else {*/
          if (event.target.files[0]) {
            this.url = URL.createObjectURL(event.target.files[0])
            this.pic_Profile = this.url
            // this.pic_Profile = require('@/assets/img/ShowfPict.jpg')
          } else {
            this.pic_Profile = require('@/assets/img/NonPic.png')
          }

          this.selectFile = event.target.files[0].name
          /*}*/

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + this.getExtension(event.target.files[0].name).toLowerCase()
          })
        }

      } else {
        this.selectFile = ''
        this.pic_Profile = require('@/assets/img/NonPic.png')
      }
    },
    getExtension(filename) {
      var parts = filename.split('.');
      return parts[parts.length - 1];
    },
    onUpload: function (dataFile) {
      const fd = new FormData()
      fd.append('file', dataFile, dataFile.name)
      const headerAxios = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'WithCredentials': true,
          "Access-Control-Allow-Origin": "*"
          // "Accept": 'multipart/form-data'
        }
      }

      axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
        if (res.data.status) {
          return res.data.path
        } else {
          return null
        }
      })
    },
    ChooseRelative: function (RequestId) {
      this.PicProfile = ''
      this.RelativeData.map((item) => {
        if (RequestId == item.id) {
          this.nameTh = item.firstName
          this.surnameTh = item.lastName
          this.idcard = item.citizenId
          this.brithDay = item.birthdate
          this.vehicleReg = item.license_plate
          this.vehicleRegProvice = item.provinces_id

          if (item.sex == 'M') {
            this.gender = 'ชาย'
          } else {
            this.gender = 'หญิง'
          }
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact_view/request_id/' + item.id).then(res => {
            if (res.data) {
              res.data.map((contact_i) => {
                switch (contact_i.contact_types_id) {
                  case '1':
                    this.email = contact_i.value
                    break
                  case  '4':
                    this.phoneMoblie = contact_i.value
                    break
                  case  '5':
                    this.phoneHome = contact_i.value
                    break
                  case  '6':
                    this.address = contact_i.value
                    break
                  default:
                    break;
                }
              })
            } else {
              this.phoneMoblie = ''
              this.phoneHome = ''
              this.email = ''
              this.address = ''
            }
          })

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment_view/person_id/' + item.person_id).then(res => {
            if (res.data) {
              res.data.map((attachment_i) => {
                switch (attachment_i.attachment_types_id) {
                  case '1':
                    this.PicProfile = attachment_i.url
                    axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_wish_id/4/citizenId/' + item.citizenId + '/?sort=id_DESC&limit=1').then(res => {
                      if (res.data) {
                        this.PicProfile = res.data.url_display
                      } else {
                        this.PicProfile = attachment_i.url
                      }
                      console.log(this.PicProfile)
                    })
                    // this.selectFile = ConstData.ConnectionHost + '/rest/files/' + attachment_i.url
                    // this.url = URL.createObjectURL(event.target.files[0])
                    // this.pic_Profile = this.selectFile
                    break
                  case  '2':
                    this.FilePersonal = ConstData.ConnectionHost + '/rest/files/' + attachment_i.url
                    this.ImagePersonCopy = attachment_i.url
                    break
                  case  '4':
                    this.FileHome = ConstData.ConnectionHost + '/rest/files/' + attachment_i.url
                    this.ImageHome = attachment_i.url
                    this.ChooseTypePicFunc2()
                    break
                  default:
                    break;
                }
              })
              this.ChooseTypePicFunc()
            } else {
              this.PicProfile = ''
              this.selectFile = ''
              this.FilePersonal = ''
              this.FileHome = ''
              this.ImagePersonCopy = ''
              this.ImageHome = ''
            }
          })
        }
      })
    },
    ChooseTypePicFunc() {
      if (this.ChooseTypePic == '1') {
        this.selectFile = this.PicProfile
      } else {
        this.selectFile = require('@/assets/img/NonPic.png')
      }
    },
    ChooseTypePicFunc2() {
      if (this.FileHomeDump == '') {
        this.FileHomeDump = this.ImageHome
      }
      if (this.ChooseTypePic2 == '1') {
        this.FileHome = this.FileHomeDump
      } else {
        this.ImageHomeType = false
        this.pdfHomeType = false
        this.ImageHome = ''
        this.FileHome = ''
      }
    },
    CheckStatusRegis: function () {
      if (this.StatusRegis == 1) {
        this.dataFormSubmit.request.request_wish_id = this.StatusRegis;
        this.choosePic = true;
        this.nameTh = ''
        this.surnameTh = ''
        this.idcard = ''
        this.brithDay = ''
        this.gender = ''
        this.phoneMoblie = ''
        this.phoneHome = ''
        this.email = ''
        this.address = ''
        this.selectFile = ''
        this.pic_Profile = require('@/assets/img/NonPic.png')
        this.ChooseTypePic = '0'
      } else {
        this.FileHomeDump = ''
        this.dataFormSubmit.request.request_wish_id = this.StatusRegis;
        this.RelativeData = []
        this.StatusRelative = 0
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_types_id/2/request_wish_id/1/perid/' + this.perid + '/?sort=id_DESC').then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              this.RelativeData = res.data
            } else {
              this.RelativeData.push(res.data)
            }
          } else {
            this.RelativeData = []
          }
        })
      }
    },
    blackMenu: function () {
      this.$router.push('/')
    },
    autoTab: function () {
      if (this.idcard.length <= 13) {
        this.valueOld = this.idcard
      } else {
        this.idcard = this.valueOld
      }

    },
    autoTabMobile: function () {
      if (this.phoneMoblie.length <= 10) {
        this.valuePhoneMobileOld = this.phoneMoblie
      } else {
        this.phoneMoblie = this.valuePhoneMobileOld
      }

    },
    autoTabHome: function () {
      if (this.phoneHome.length <= 9) {
        this.valuePhoneHomeOld = this.phoneHome
      } else {
        this.phoneHome = this.valuePhoneHomeOld
      }

    },
    SetDateToDB: function (DateTpDB) {
      var DateSelect = DateTpDB;
      var Day = DateSelect.split('/')[0];
      var Month = DateSelect.split('/')[1];
      var Year = DateSelect.split('/')[2];
      return Year + "-" + Month + "-" +
          Day;
    },
    getCondition() {
      return new Promise(resolve => {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/condition/active/1/perid/' + this.perid + '/?limit=1').then(res => {
          if (res.data) {
            resolve({
              status: true,
              data: res.data
            })
          } else {
            resolve({
              status: false,
              data: null
            })
          }
        })
      })
    },
    parseJwt: function (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }
  },
  components: {
    Cropper
  },
  mounted() {
    axios.post(ConstData.ConnectionHost + '/saveSessions.php', queryString.stringify({
      session: 'https://medhr.medicine.psu.ac.th/CardRegister/#/'
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    // if (new Date() >= new Date('2022-12-31')) {
    //   this.$swal.fire({
    //     icon: 'error',
    //     title: 'ขออภัย!!!',
    //     text: 'หมดระยะเวลาการทำบัตรญาติ'
    //   })
    //   this.$router.push('/')
    // } else {
    setInterval(() => {
      this.ChangeStyle = {
        "font-weight: bold": "bold",
        "font-size": "16px",
        "color": "red",
        "text-shadow": "0px 0px 50px rgba(255, 0, 0, 1)"
      }
    }, 1000)
    setInterval(() => {
      this.ChangeStyle = {
        "font-weight: bold": "bold",
        "font-size": "16px",
        "color": "blue",
        "text-shadow": "0px 0px 50px rgba(0, 30, 255, 1)"
      }
    }, 1500)
    setTimeout(function () {
      let Jquery = document.createElement('script')
      Jquery.setAttribute('src', 'https://code.jquery.com/jquery-2.2.4.js')
      document.head.appendChild(Jquery)
      let recaptchaScript2 = document.createElement('script')
      recaptchaScript2.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/bootstrap.min.js')
      document.head.appendChild(recaptchaScript2)
      let recaptchaScript3 = document.createElement('script')
      recaptchaScript3.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/jquery.bootstrap.wizard.js')
      document.head.appendChild(recaptchaScript3)
      let recaptchaScript4 = document.createElement('script')
      recaptchaScript4.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/demo.js')
      document.head.appendChild(recaptchaScript4)
      let recaptchaScript5 = document.createElement('script')
      recaptchaScript5.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/paper-bootstrap-wizard.js')
      document.head.appendChild(recaptchaScript5)
      let recaptchaScript6 = document.createElement('script')
      recaptchaScript6.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/jquery.validate.min.js')
      document.head.appendChild(recaptchaScript6)
    }, 100)
    setTimeout(function () {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://code.jquery.com/jquery-2.2.4.js')
      document.head.appendChild(recaptchaScript)
      let recaptchaScript2 = document.createElement('script')
      recaptchaScript2.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/bootstrap.min.js')
      document.head.appendChild(recaptchaScript2)
      let recaptchaScript3 = document.createElement('script')
      recaptchaScript3.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/jquery.bootstrap.wizard.js')
      document.head.appendChild(recaptchaScript3)
      let recaptchaScript4 = document.createElement('script')
      recaptchaScript4.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/demo.js')
      document.head.appendChild(recaptchaScript4)
      let recaptchaScript5 = document.createElement('script')
      recaptchaScript5.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/paper-bootstrap-wizard.js')
      document.head.appendChild(recaptchaScript5)
      let recaptchaScript6 = document.createElement('script')
      recaptchaScript6.setAttribute('src', 'https://demos.creative-tim.com/paper-bootstrap-wizard/assets/js/jquery.validate.min.js')
      document.head.appendChild(recaptchaScript6)
    }, 300)

    /*this.nameTh = 'ชฎาพร'
    this.surnameTh = 'สังขชาติ'
    this.idcard = '1909888888'
    this.brithDay = '12/09/2531'
    this.gender = 'ชาย'
    this.phoneMoblie = '090454078'
    this.phoneHome = '094545757'
    this.email = 'thawat@gmail.com'
    this.address = '242 /6'*/

    var DateNow = new Date();
    DateNow.setFullYear(DateNow.getFullYear() + 2);
    this.DateExpire = DateNow.getDate() + '-' + (DateNow.getMonth()) + '-' + (DateNow.getFullYear() + 543);


    if (this.$cookies.get('access_token')) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$cookies.get('access_token');
    } else {
      // this.$cookies.set('access_token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwZXJpZCI6IjQ2NzkyIiwibmFtZSI6Ilx1MGUxOFx1MGUyN1x1MGUzMVx1MGUwYVx1MGUwYVx1MGUzMVx1MGUyMiIsInN1cm5hbWUiOiJcdTBlMDhcdTBlMzFcdTBlMTlcdTBlMTdcdTBlMjNcdTBlMTdcdTBlMzRcdTBlMWVcdTBlMjJcdTBlNGMifQ.YTW8R5wDrEPUPv5HkvfewbiQKBwpF18o5ZBxwZPtk1o')

      this.$session.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/')
      this.$cookies.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/')
      window.location.href = ConstData.ConnectionHost + '/CardRegister/#/';
    }

    axios.post(ConstData.ConnectionHost + '/CardRegister/service.php', {
      queryName: 'PersonalDataByPerson',
      param: btoa(encodeURIComponent(JSON.stringify({
        perid: this.parseJwt(this.$cookies.get('access_token')).perid
      })))
    }).then(res => {
      if (res.data && res.data.staffData.length > 0) {
        this.perid = res.data.staffData[0].perid;
        this.namePerson = res.data.staffData[0].name = " " + res.data.staffData[0].surname

        if (res.data.dormData != null && res.data.dormData.length > 0) {
          this.dorm = res.data.dormData[0].room_name
          this.dorm2 = res.data.dormData[0].dorm_name
        }
        // this.perid = '618';

        if (this.perid != null || this.perid != '') {
          this.getCondition().then(resCondi => {
            if (resCondi.status) {
              this.Count = parseInt(resCondi.data.count)
            } else {
              this.Count = 3
            }
          })
        }

        if (res.data.dormData != null && res.data.dormData.length > 0) {
          this.dorm = res.data.dormData[0].room_name
          this.dorm2 = res.data.dormData[0].dorm_name
          var CheckData = false
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative_view/active/1/?limit=9999').then(res => {
            if (res.data) {
              if (res.data.length > 0) {
                res.data.map((item) => {
                  if (item.perid == this.perid) {
                    CheckData = true
                  }
                })

                if (!CheckData) {
                  if (this.dorm == 'ดาหลา1') {
                    if (res.data.staffData[0].pos_id == 'C66') {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด',
                        text: 'ไม่สามารถทำบัตรญาติได้'
                      })
                      this.$router.push('/')
                    }
                  } else if (this.dorm == 'บ้านพักแพทย์' || this.dorm == 'บินหลา3' || this.dorm == 'ศรีตรัง 8') {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด',
                      text: 'ไม่สามารถทำบัตรญาติได้ เนื่องจากหอพักที่ท่านอยู่ไม่อนุญาติให้ทำบัตรญาติได้'
                    })
                    this.$router.push('/')
                    // } else if(this.dorm == 'ดาราคาม 1' || this.dorm == 'ดาราคาม 2') {
                  } else {
                    if (res.data.staffData[0].pos_id != 'C53' && res.data.staffData[0].pos_id != 'C54' && res.data.staffData[0].pos_id != 'C55'
                        && res.data.staffData[0].pos_id != 'C56' && res.data.staffData[0].pos_id != 'C57' && res.data.staffData[0].pos_id != 'C58'
                        && res.data.staffData[0].pos_id != 'C59' && res.data.staffData[0].pos_id != 'C60') {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด',
                        text: 'ไม่สามารถทำบัตรญาติได้'
                      })
                      this.$router.push('/')
                    }
                  }
                }
              } else {
                if (res.data.perid == this.perid) {
                  CheckData = true
                }
                if (!CheckData) {
                  if (this.dorm == 'ดาหลา1') {
                    if (res.data.staffData[0].pos_id == 'C66') {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด',
                        text: 'ไม่สามารถทำบัตรญาติได้'
                      })
                      this.$router.push('/')
                    }
                  } else if (this.dorm == 'บ้านพักแพทย์' || this.dorm == 'บินหลา3' || this.dorm == 'ศรีตรัง 8') {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด',
                      text: 'ไม่สามารถทำบัตรญาติได้ เนื่องจากหอพักที่ท่านอยู่ไม่อนุญาติให้ทำบัตรญาติได้'
                    })
                    this.$router.push('/')
                    // } else if(this.dorm == 'ดาราคาม 1' || this.dorm == 'ดาราคาม 2') {
                  } else {
                    if (res.data.staffData[0].pos_id == 'C67' || res.data.staffData[0].pos_id == 'C91' || res.data.staffData[0].pos_id == 'C92'
                        || res.data.staffData[0].pos_id == 'C61') {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด',
                        text: 'ไม่สามารถทำบัตรญาติได้'
                      })
                      this.$router.push('/')
                    }
                  }
                }
              }
            } else {
              if (this.dorm == 'ดาหลา1') {
                if (res.data.staffData[0].pos_id == 'C66') {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'ไม่สามารถทำบัตรญาติได้'
                  })
                  this.$router.push('/')
                }
              } else if (this.dorm == 'บ้านพักแพทย์' || this.dorm == 'บินหลา3' || this.dorm == 'ศรีตรัง 8') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'ไม่สามารถทำบัตรญาติได้ เนื่องจากหอพักที่ท่านอยู่ไม่อนุญาติให้ทำบัตรญาติได้'
                })
                this.$router.push('/')
                // } else if(this.dorm == 'ดาราคาม 1' || this.dorm == 'ดาราคาม 2') {
              } else {
                if (res.data.staffData[0].pos_id == 'C67' || res.data.staffData[0].pos_id == 'C91' || res.data.staffData[0].pos_id == 'C92'
                    || res.data.staffData[0].pos_id == 'C61') {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'ไม่สามารถทำบัตรญาติได้'
                  })
                  this.$router.push('/')
                }
              }
            }
          })
        } else {
          if (this.perid != '43654' && this.perid != '46792') {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สามารถทำบัตรญาติได้ เนื่องจากไม่พบข้อมูลหอพัก'
            })
            this.$router.push('/')
          } else {
            this.dorm = 'ทดสอบข้อมูล'
            this.dorm2 = 'ทดสอบข้อมูล'
          }
        }
      }
    })

    axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/provinces_view/?limit=100').then(res => {
      if (res.data) {
        if (res.data.length > 0) {
          this.ProviceData = res.data
        } else {
          this.ProviceData.push(res.data)
        }
      } else {
        this.ProviceData = []
      }
    })
    // }
  }
}
</script>

<style scoped>
.swal2-popup {
  font-size: 1.6rem !important;
}

.cropper-wrapper {
  position: relative;
  height: 350px;
  width: 400px;
  background: black;
  padding: 5px;
}

.cropper-background {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50%;
  filter: blur(5px);
  opacity: 0.25;
}
</style>
